// 健康管理課ページで使用
const optionOpen = () => {
  const optionElm = document.getElementById('option');
  const panel = optionElm.nextElementSibling;
  optionElm.classList.add('active');
  panel.style.maxHeight = panel.scrollHeight + 'px';
  // scroll
  const rect = optionElm.getBoundingClientRect();
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const position = rect.top + scrollTop;
  // スクロール処理
  window.scrollTo({
    top: position - 16,
    left: 0,
    behavior: 'smooth'
  });
}
